import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {getTeacherAccessGroups} from "./__graphql-types__/getTeacherAccessGroups.ts";

export const TEACHER_ACCESS_GROUPS_QUERY: GqlOperation<getTeacherAccessGroups> =
    gqlOp(gql`
        query getTeacherAccessGroups {
            user {
                id
                hasAccessToAIGuideDistrictClassroomTeacher
            }
        }
    `);
